
export default {
  name: 'image-animation',
  mixins: [],
  data () {
    return {
      needIntersection: true,
      mobile: true
    }
  },
  props: {
    delay: 0,
    overlay: '',
    color: ''
  },
  mounted () {
    this.mobile = this.$store.state.ua.platform.type !== 'desktop'
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)
  },
  methods: {
    show () {
      this.$el.classList.remove('hidden')
    },
    hide (up = true) {
      this.$el.classList.add('hidden')
    }
  }
}
